

const BuildURL = {
  Type: process.env.REACT_APP_ENV, //Production OR Staging OR Local OR Development OR Integration OR IntegrationDev
  Environment: {
    Production: {
      IPADDRESS: "lob.tmilltd.com",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: true,
      PORT: '',
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "https://lobsapintrfc.tmilltd.com/",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "6b7a6fea-7034-4edd-8dcd-19139f60d852",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: "https://lob.tmilltd.com/railways"
      },
      RAILWAYS_POWER_BI_URL:process.env.RAILWAYS_POWER_BI_URL,
      RAILWAYS_DEBTORS_URL:process.env.RAILWAYS_DEBTORS_URL
    },
    AZURE_QA: {
      IPADDRESS: "qarailways.azurewebsites.net",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: true,
      PORT: '',
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'https://qarailways.azurewebsites.net/railways'
      },
      RAILWAYS_POWER_BI_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-8b-86-a6-94-a5-a0-a8-97-96-95-b5-8f-97-ac-ad-94-8a-78-79-98-92-96-b5-9a-a3-bc-bb-a0-cd-a5-c9-a5-9e-b1-d2-b3-af-bf-d7-ad-a3-c4-c9-b0-cd-b9-dd-af-d0-df-d2-ce-ae-b5-a3-b7-d9-dc-dd-cb-c7-c6-e1-c3-a9-bd-ab-c6-cf-c5-b2-cb-c3-e7-f5-d0-ca-d5-fc-d3-da-b9-f1-e3-bd-e1-c0-da-e6-e6-fb-df-10d-ea-fe-e3-eb-e1-ce-e7-e2-e5-d1-eb-108-e9-114-eb-110-f1-10e-f5-111-102-e2",
      RAILWAYS_DEBTORS_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-b1-81-b1-87-82-8d-b5-98-93-99-b5-8f-97-91-75-94-9a-78-79-98-92-a6-b6-9a-a6-96-ba-ab-c0-9d-c9-af-c1-9d-8b-b4-af-a1-8f-b8-a3-a1-96-bc-b7-cf-99-af-d0-df-d2-ce-ae-b5-a3-b7-d9-b6-d9-c0-ed-c1-a7-cf-e4-bd-ab-c6-cf-c6-ea-cb-e9-d5-f5-d0-ca-d6-ed-e0-da-b8-be-d8-f8-de-f6-da-e3-e2-fc-df-c5-da-101-f0-101-ff-ce-e8-cd-e1-cf-eb-e2-ea-da"
    },
    QA: {
      IPADDRESS: "demo.msr-it.com",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: false,
      PORT: 40115,
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60"
      },
      RAILWAYS_POWER_BI_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-8b-86-a6-94-a5-a0-a8-97-96-95-b5-8f-97-ac-ad-94-8a-78-79-98-92-96-b5-9a-a3-bc-bb-a0-cd-a5-c9-a5-9e-b1-d2-b3-af-bf-d7-ad-a3-c4-c9-b0-cd-b9-dd-af-d0-df-d2-ce-ae-b5-a3-b7-d9-dc-dd-cb-c7-c6-e1-c3-a9-bd-ab-c6-cf-c5-b2-cb-c3-e7-f5-d0-ca-d5-fc-d3-da-b9-f1-e3-bd-e1-c0-da-e6-e6-fb-df-10d-ea-fe-e3-eb-e1-ce-e7-e2-e5-d1-eb-108-e9-114-eb-110-f1-10e-f5-111-102-e2",
      RAILWAYS_DEBTORS_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-b1-81-b1-87-82-8d-b5-98-93-99-b5-8f-97-91-75-94-9a-78-79-98-92-a6-b6-9a-a6-96-ba-ab-c0-9d-c9-af-c1-9d-8b-b4-af-a1-8f-b8-a3-a1-96-bc-b7-cf-99-af-d0-df-d2-ce-ae-b5-a3-b7-d9-b6-d9-c0-ed-c1-a7-cf-e4-bd-ab-c6-cf-c6-ea-cb-e9-d5-f5-d0-ca-d6-ed-e0-da-b8-be-d8-f8-de-f6-da-e3-e2-fc-df-c5-da-101-f0-101-ff-ce-e8-cd-e1-cf-eb-e2-ea-da"
   },
    Development: {
      IPADDRESS: "demo.msr-it.com",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: false,
      PORT: 40114,
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40114",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'http://localhost:3000/railways'
      },
      RAILWAYS_POWER_BI_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-8b-86-a6-94-a5-a0-a8-97-96-95-b5-8f-97-ac-ad-94-8a-78-79-98-92-96-b5-9a-a3-bc-bb-a0-cd-a5-c9-a5-9e-b1-d2-b3-af-bf-d7-ad-a3-c4-c9-b0-cd-b9-dd-af-d0-df-d2-ce-ae-b5-a3-b7-d9-dc-dd-cb-c7-c6-e1-c3-a9-bd-ab-c6-cf-c5-b2-cb-c3-e7-f5-d0-ca-d5-fc-d3-da-b9-f1-e3-bd-e1-c0-da-e6-e6-fb-df-10d-ea-fe-e3-eb-e1-ce-e7-e2-e5-d1-eb-108-e9-114-eb-110-f1-10e-f5-111-102-e2",
      RAILWAYS_DEBTORS_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-b1-81-b1-87-82-8d-b5-98-93-99-b5-8f-97-91-75-94-9a-78-79-98-92-a6-b6-9a-a6-96-ba-ab-c0-9d-c9-af-c1-9d-8b-b4-af-a1-8f-b8-a3-a1-96-bc-b7-cf-99-af-d0-df-d2-ce-ae-b5-a3-b7-d9-b6-d9-c0-ed-c1-a7-cf-e4-bd-ab-c6-cf-c6-ea-cb-e9-d5-f5-d0-ca-d6-ed-e0-da-b8-be-d8-f8-de-f6-da-e3-e2-fc-df-c5-da-101-f0-101-ff-ce-e8-cd-e1-cf-eb-e2-ea-da"
   },
    Local: {
      IPADDRESS: "localhost",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: false,
      PORT: 8084,
      EMAIL_SERVICE_END_POINT: "http://localhost:8095",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'http://localhost:3000/railways'
      },
      RAILWAYS_POWER_BI_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-8b-86-a6-94-a5-a0-a8-97-96-95-b5-8f-97-ac-ad-94-8a-78-79-98-92-96-b5-9a-a3-bc-bb-a0-cd-a5-c9-a5-9e-b1-d2-b3-af-bf-d7-ad-a3-c4-c9-b0-cd-b9-dd-af-d0-df-d2-ce-ae-b5-a3-b7-d9-dc-dd-cb-c7-c6-e1-c3-a9-bd-ab-c6-cf-c5-b2-cb-c3-e7-f5-d0-ca-d5-fc-d3-da-b9-f1-e3-bd-e1-c0-da-e6-e6-fb-df-10d-ea-fe-e3-eb-e1-ce-e7-e2-e5-d1-eb-108-e9-114-eb-110-f1-10e-f5-111-102-e2",
      RAILWAYS_DEBTORS_URL:"77-84-85-82-86-4e-44-45-78-88-89-48-8b-8b-94-83-91-82-8a-50-86-93-92-55-9d-91-8e-a1-6a-9e-6a-93-a8-7a-a3-7b-9d-a3-9e-8f-b1-81-b1-87-82-8d-b5-98-93-99-b5-8f-97-91-75-94-9a-78-79-98-92-a6-b6-9a-a6-96-ba-ab-c0-9d-c9-af-c1-9d-8b-b4-af-a1-8f-b8-a3-a1-96-bc-b7-cf-99-af-d0-df-d2-ce-ae-b5-a3-b7-d9-b6-d9-c0-ed-c1-a7-cf-e4-bd-ab-c6-cf-c6-ea-cb-e9-d5-f5-d0-ca-d6-ed-e0-da-b8-be-d8-f8-de-f6-da-e3-e2-fc-df-c5-da-101-f0-101-ff-ce-e8-cd-e1-cf-eb-e2-ea-da"
   },
  },
  getServiceURL: function () {
    var SERVICEADDRESS;
    var port = BuildURL.Environment[BuildURL.Type].PORT;
    var IPADDRESS = BuildURL.Environment[BuildURL.Type].IPADDRESS;
    var isSecure = BuildURL.Environment[BuildURL.Type].ISSECURE;
    var httpText;
    if (isSecure) httpText = "https://";
    else httpText = "http://";
    if (port !== "") {
      //HOSTADDRESS =  'http://' + IPADDRESS + ':' + PORT + '/' + APPDEFAULTURL;
      SERVICEADDRESS =
        httpText +
        IPADDRESS +
        ":" +
        port +
        "/" +
        BuildURL.Environment[BuildURL.Type].APPDEFAULTURL;
    } else {
      //HOSTADDRESS = 'http://' + IPADDRESS + '/' + APPDEFAULTURL;
      SERVICEADDRESS =
        httpText +
        IPADDRESS +
        "/" +
        BuildURL.Environment[BuildURL.Type].APPDEFAULTURL;
    }
    return SERVICEADDRESS;
  },
  getEmailServiceEndpoint: function () {
    return BuildURL.Environment[BuildURL.Type].EMAIL_SERVICE_END_POINT;
  },
  getSapServiceEndpointConfig: function () {
    return BuildURL.Environment[BuildURL.Type].SAP_CONNECTION_DETAILS;
  },
  geAdAuthConfig: function () {
    return BuildURL.Environment[BuildURL.Type].AD_AUTHENTICATION;
  },
};
export default { BuildURL };
